import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './index.less';
import { SessionList } from '../session-list/index.js';
import { ClawSidebarSessionList } from '../claw-session-list/index.js';
import { Search } from '../search/index.js';
import { Global03ActionSousuonewLineIcon } from '@kim/icon';
import { useAIWindowContext } from '../../../Context/context.js';
import useClawWsStore from '@src/stores/useClawWsStore';
import {
  MAINAGENT_ROUTE_BASE,
  isPathUnderBase,
} from '@src/utils/mainagent-route';

/** Claw 主路径 + 龙虾集市 /skills，与 Mario Claw Tab 一致 */
const CLAW_HISTORY_PATH_BASES = [
  MAINAGENT_ROUTE_BASE,
  '/skills',
  '/lab',
  '/agents',
] as const;
import { isClawSidebarHistoryPath } from '../../clawHistoryRoutes';

export const SidebarMenu = () => {
  const { conversationList } = useAIWindowContext();
  const { sessions: clawSessions } = useClawWsStore();
  const [isSearching, setIsSearching] = useState(false);
  const location = useLocation();
  const isClawHistoryRoute = isClawSidebarHistoryPath(location.pathname);
  const currentModeTab: 'claw' | 'normal' = isClawHistoryRoute
    ? 'claw'
    : 'normal';

  useEffect(() => {
    // 模式 Tab 切换时退出搜索，避免把一个 Tab 的搜索态带到另一个 Tab
    setIsSearching(false);
  }, [currentModeTab]);

  const showSearchIcon = isClawHistoryRoute
    ? clawSessions.length > 0
    : conversationList.length > 0;

  return (
    <div className="kim-ai-mario-sidebar-menu">
      {isSearching ? (
        <Search onExit={() => setIsSearching(false)} />
      ) : (
        <>
          {isClawHistoryRoute ? <ClawSidebarSessionList /> : <SessionList />}
          {showSearchIcon && (
            <Global03ActionSousuonewLineIcon
              size={16}
              className="search-icon"
              onClick={() => setIsSearching(true)}
            />
          )}
        </>
      )}
    </div>
  );
};
